import React, {useContext, useEffect} from "react";
import {Box, Stack} from "@mui/material";
import {useNavigate} from "react-router-dom";
import "../flow-layout/main.css";
import {WebSettingsContext} from "../../context/WebSettingsContext";
import {SignInContext} from "../../context/SignInContext";
import {SidebarMenu} from "../flow-layout/SIdebarMenu";
import {registrySidebarMenuItems} from "../../pages/registry-project/registry-project-routes";
import {RegistryProjectHeader} from "./RegistryProjectHeader";

// Layout for a project from the Project API: project header, flow-layout sidebar. Pages that work on one language
// show their own SubProjectSelect.
export const RegistryProjectLayout = ({project, subProject, role, basePath, children}) => {
  const {settings} = useContext(WebSettingsContext);
  const {currentUser} = useContext(SignInContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser !== null) {
      const isAdmin = currentUser?.roles?.includes("admin");
      if (!isAdmin && settings?.underMaintenance) {
        navigate("/under-maintenance");
      }
    }
  }, [settings, currentUser, navigate]);

  return (
    <Stack direction={"column"} sx={{width: "100vw", height: "100vh", overflow: "hidden", bgcolor: "transparent"}}>
      <RegistryProjectHeader project={project} role={role}/>
      <Box sx={{flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "row"}}>
        <SidebarMenu
          items={registrySidebarMenuItems}
          project={{basePath, project, subProject}}
          userRole={role}
          variant={"pill"}
        />
        {/* Pages sit on the light grey dashboard surface; header and sidebar stay white */}
        <Box sx={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          height: "100%",
          overflow: "auto",
          bgcolor: "#F7F7FB",
          display: "flex",
          flexDirection: "column"
        }}>
          {children}
        </Box>
      </Box>
    </Stack>
  );
};
